import React from "react";
import styled from "styled-components";
import { AlgoFieldId } from "@radarly/models/insight-pages/model";
import Emojis from "../../../../../assets/discovery-emojis";

export const MELTMOJIS = {
  imagecluster_default: Emojis.ImageclusterDefault,
  significance_affect_negative: Emojis.AffectNegative,
  significance_affect_positive: Emojis.AffectPositive,
  significance_content: Emojis.MentionKeyphrases,
  significance_emotion_anger: Emojis.Anger,
  significance_emotion_disgust: Emojis.Disgust,
  significance_emotion_fear: Emojis.Fear,
  significance_emotion_joy: Emojis.Joy,
  significance_emotion_love: Emojis.Love,
  significance_emotion_sadness: Emojis.Sadness,
  significance_emotion_suprise: Emojis.Surprise,
  significance_hashtag: Emojis.Hashtags,
  significance_keyphrase: Emojis.MentionKeyphrases,
  significance_negative: Emojis.NegativePosts,
  significance_positive: Emojis.PositivePosts,
  significance_reviews: Emojis.Review,
  viraposts_top: Emojis.Viral,
  volumechange_down: Emojis.DecreasePublication,
  volumechange_up: Emojis.IncreasePublication,
};

const getMeltmoji = (algoFieldId: AlgoFieldId) => MELTMOJIS[algoFieldId];

export interface IProps {
  algoFieldId: AlgoFieldId;
}

const Root = styled.img`
  width: 24px;
  height: 24px;
`;

const RadarlyInsightPagesDiscoveryMeltmoji = ({ algoFieldId }: IProps) => {
  const meltmoji = getMeltmoji(algoFieldId);

  return meltmoji ? <Root src={getMeltmoji(algoFieldId)} /> : <></>;
};

export default RadarlyInsightPagesDiscoveryMeltmoji;
